export const TELEGRAM_CHANNEL_URL = 'https://t.me/by_pass_vpn';
